// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__ZEvKC","inner":"Form_inner__2aQZQ","range":"Form_range__1OhcD","name":"Form_name__1zmjV","actions":"Form_actions__2iARd"};